import ActionType from 'actions/ActionType'

export default (state = true, action) => {
	switch (action.type) {
		case ActionType.Tasks.TOGGLE_ACTION_TYPE_PANEL:
			return !Boolean(state)
		// case ActionType.Tasks.RECEIVE_TASK:
		//   return false
		default:
			return state
	}
}
